<template>
  <div class="company-tree">
    <div class="tree-container">
      <ul class="root-list">
        <TreeNode
          v-for="node in treeData"
          :key="node.id"
          :node="node"
          :search-keyword="searchKeyword"
          @node-selected="handleNodeSelected"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import TreeNode from './TreeNode.vue';

export default {
  name: 'CompanyTreeView',
  components: {
    TreeNode,
  },
  emits: ['node-selected'],
  props: {
    initialSelectedNode: {
      type: Object,
      default: null
    },
    searchKeyword: {
      type: String,
      default: ''
    },
    // 기본으로 열어둘 노드의 코드
    defaultCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      treeData: null,
    };
  },
  mounted() {
    this.loadCompanyTree();
  },
  methods: {
    async loadCompanyTree() {
      const response = await this.$store.dispatch(
        "company/LOAD_MY_VIRTUAL_COMPANY",
        {}
      );
      if (response && response.data && response.data.company_group && response.data.company_group.tree) {
        this.treeData = response.data.company_group.tree;

        // defaultCode가 존재하는 경우, 해당 노드를 찾아서 열어둠
        if (this.defaultCode) {
          this.$nextTick(() => {
            this.expandToNode(this.treeData, this.defaultCode);
          });
        }
      }
    },
    reset() {
      // 모든 TreeNode의 isOpen 상태를 false로 설정
      this.$root.$emit('reset-tree');

      // defaultCode가 있다면 해당 노드까지의 경로를 펼침
      if (this.defaultCode) {
        this.$nextTick(() => {
          this.expandToNode(this.treeData, this.defaultCode);
        });
      }
    },
    /**
     * 전달된 코드를 가진 노드를 찾아서 확장하고 선택한다.
     * @param code
     */
    changeNode(code) {
      this.$nextTick(() => {
        this.expandToNode(this.treeData, code);

        // 해당 노드를 선택한다.
        const foundNode = this.findNodeByCode(this.treeData, code);
        if (foundNode) {
          this.handleNodeSelected(foundNode);
        }
      });
    },
    /**
     * 특정 코드를 가진 노드를 찾는다.
     * @param nodes
     * @param targetCode
     * @returns {*}
     */
    findNodeByCode(nodes, targetCode) {
      if (!nodes) return null;

      for (const node of nodes) {
        if (node.code === targetCode) {
          return node;
        }

        if (node.children && node.children.length > 0) {
          const found = this.findNodeByCode(node.children, targetCode);
          if (found) {
            return found;
          }
        }
      }

      return null;
    },
    // 특정 코드를 가진 노드까지의 경로를 찾아서 확장하는 재귀 함수
    expandToNode(nodes, targetCode) {
      if (!nodes) return false;

      for (const node of nodes) {
        // 현재 노드가 target인 경우
        if (node.code === targetCode) {
          return true;
        }

        // 자식 노드들 중에 target이 있는지 확인
        if (node.children && node.children.length > 0) {
          const found = this.expandToNode(node.children, targetCode);
          if (found) {
            // target을 찾았다면 현재 노드를 열어둠
            this.$root.$emit('expand-to-code', node.code);
            return true;
          }
        }
      }

      return false;
    },
    handleNodeSelected(nodeData) {
      this.$emit('node-selected', nodeData);
    }
  },
};
</script>

<style scoped>
.company-tree {}

.tree-container {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 4px;
}

.root-list {
  padding: 0;
  margin: 0;
}
</style>
